<template>
    <div class="select_position">
        <div class="caption">{{caption}}</div>
        <div class="text">形状と位置を選択してください</div>
        <div v-if="temp_item.item_type === ITEM_TYPE_WALL" class="pos_list">
            <div @click="setPosition(wall_paper1)"><img src="../../../assets/img/pos/init_pos_wallpaper1.png" alt="pos_1"></div>
            <div @click="setPosition(wall_paper2)"><img src="../../../assets/img/pos/init_pos_wallpaper2.png" alt="pos_2"></div>
            <div @click="setPosition(wall_paper3)"><img src="../../../assets/img/pos/init_pos_wallpaper3.png" alt="pos_3"></div>
            <div @click="setPosition(wall_paper4)"><img src="../../../assets/img/pos/init_pos_wallpaper4.png" alt="pos_4"></div>
            <div @click="setPosition(wall_paper5)"><img src="../../../assets/img/pos/init_pos_wallpaper5.png" alt="pos_5"></div>
            <div @click="setPosition(wall_paper6)"><img src="../../../assets/img/pos/init_pos_wallpaper6.png" alt="pos_6"></div>
        </div>
        <div v-else-if="temp_item.item_type === ITEM_TYPE_CURTAIN" class="pos_list">
            <div @click="setPosition(curtain1)"><img src="../../../assets/img/pos/init_pos_curtain1.png" alt="pos_1"></div>
            <div @click="setPosition(curtain2)"><img src="../../../assets/img/pos/init_pos_curtain2.png" alt="pos_2"></div>
            <div @click="setPosition(curtain3)"><img src="../../../assets/img/pos/init_pos_curtain3.png" alt="pos_3"></div>
        </div>
        <div v-else-if="temp_item.item_type === ITEM_TYPE_FLOOR" class="pos_list">
            <div @click="setPosition(floor1)"><img src="../../../assets/img/pos/init_pos_floor1.png" alt="pos_1"></div>
            <div @click="setPosition(floor2)"><img src="../../../assets/img/pos/init_pos_floor2.png" alt="pos_2"></div>
            <div @click="setPosition(floor3)"><img src="../../../assets/img/pos/init_pos_floor3.png" alt="pos_3"></div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations, mapActions } from 'vuex'
    import CONST from '../../../assets/js/const'
    import Util from '../../../assets/js/util'

    export default {
        name: "SelectPosition",
        data: () => ({
            ...CONST,

            wall_paper1: [[0,0], [35,5], [0,100], [35,70]],
            wall_paper2: [[20,10], [80,10], [20,70], [80,70]],
            wall_paper3: [[65,5], [100,0], [65,70], [100,100]],
            wall_paper4: [[0,0], [70,0], [0,100], [70,70]],
            wall_paper5: [[10,0], [90,0], [10,70], [90,70]],
            wall_paper6: [[30,0], [100,0], [30,70], [100,100]],

            curtain1: [[5,10], [40,20], [5,95], [40,65]],
            curtain2: [[15,10], [85,10], [15,65], [85,65]],
            curtain3: [[60,20], [95,10], [60,65], [95,95]],

            floor1: [[80,70], [130,70], [0,100], [130,100]],
            floor2: [[-15,70], [115,70], [-70,115], [170,115]],
            floor3: [[-30,70], [20,70], [-30,100], [100,100]],
        }),
        computed: {
            ...mapState(["konva_stage"]),
            ...mapState('simulator', ["temp_item"]),
            caption: _this => {
                switch (_this.temp_item.item_type) {
                    case CONST.ITEM_TYPE_CURTAIN: {
                        return 'カーテン';
                    }
                    case CONST.ITEM_TYPE_WALL: {
                        return '壁紙';
                    }
                    case CONST.ITEM_TYPE_FLOOR: {
                        return '床材';
                    }
                }
            },
        },
        methods: {
            ...mapMutations(["setModal"]),
            ...mapMutations('simulator', ["updateTempItem"]),
            ...mapActions(["resetTimer"]),
            ...mapActions('simulator', ["commitTempItem"]),
            async setPosition(points) {
                this.$emit('endStep');
                const calculated_points = Util.calculatePoint(points);
                this.updateTempItem({points: calculated_points});
                await this.commitTempItem();
                this.resetTimer();
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../assets/css/define";

    .select_position{
        .caption{
            padding-bottom: 1rem;
            font-size: 18px;
            text-align: center;
        }
        .text{
            padding-bottom: 0.5rem;
        }
        .pos_list{
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            > * {
                @extend .clickable;
                width: calc((100% / 3) - 0.25rem);
                margin-bottom: 0.5rem;
                img{ width: 100% }
            }
        }
    }
</style>
